import React from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface RestRowProps {
  seconds: number;
  /** "series" - between series (or superset rounds), "superSet" - between exercises inside a superset round. */
  kind: "series" | "superSet";
}

/** Rest line inside a set table, the same rest the client gets as a timer in the live workout. */
export const RestRow = ({ seconds, kind }: RestRowProps) => {
  const { t } = useTranslation("workouts");

  return (
    <div className="text-center text-gray-700">
      <ClockCircleOutlined />
      <span className="ml-2.5 font-medium">
        {seconds > 0
          ? t(kind === "series" ? "restRow.betweenSeries" : "restRow.inSuperSet", { seconds })
          : t("restRow.none")}
      </span>
    </div>
  );
};
